export class PaginationControls2 {
  page = 1;
  limit = 20;
  offset =0 ;
  pageSize = 20;
  skip= 0;
  pageIndex = 0;
  count = 0;
  pageNo = 1;
  perPage = 20;
  autoHide = true;
  directionLinks = true;
  rotate = true;
  allData: any = [];
  limitalll = 20;
  }
  